<template>
    <div>

        <div v-if="successMessage" role="alert" class="alert alert-success alert-dismissible fade show"><strong>[✓]</strong> {{ successMessage }}
            <button type="button" data-dismiss="alert" aria-label="Close" class="close"></button>
        </div>

        <div class="row mb-3 d-flex justify-content-end">
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Ajout d'un menu</h3>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label class="form-label">Type de menu</label>
                                    <select :disabled="menu.id > 0" v-model="formMenu.type" name="type" class="form-control custom-select">
                                        <option value="menu">Menu</option>
                                        <option value="jour">Jour</option>
                                        <option value="periode">Période</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-group">
                                    <label class="form-label">Nom</label>
                                    <input  v-model="formMenu.name" type="text" class="form-control" name="name" placeholder="Nom">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer text-right">
                        <div class="d-flex">
                            <a href="/pro/menus" type="submit" class="btn btn-outline-info ml-auto">Annuler</a>
                            <button @click.prevent="save" type="submit" class="btn btn-primary ml-auto">Enregistrer</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div v-if="formMenu.calcul" class="card position-relative">
                    <div class="card-header">
                        <h3 class="card-title">Calcul </h3>
                    </div>
                    <div class="card-body">
                        <table class="table table-bordered">
                            <tbody>
                                <tr>
                                    <td>Poids net total :</td>
                                    <td>{{ Math.round(formMenu.calcul.totalPoidsPortion) }} g</td>
                                </tr>
                                <tr>
                                    <td>Empreinte CO2 :</td>
                                    <td>{{ Math.round(formMenu.calcul.gCO2e) }} CO2</td>
                                </tr>
                                <tr>
                                    <td>Energie Kcal :</td>
                                    <td>{{ Math.round(formMenu.calcul.calcul.caloriesExt) }} Kcal</td>
                                </tr>
                                <tr>
                                    <td>
                                        Green-score : <br>
                                        {{ formMenu.calcul.singlescore.ecoscore }}
                                    </td>
                                    <td>
                                        <img style="height: 45px" :src="formMenu.calcul.singlescore.ecoscore_lettre_url" class="eco-score-value" alt="">
                                    </td>
                                </tr>
                                <tr>
                                    <td>Nutri-score :</td>
                                    <td>
                                        <img style="height: 50px" :src="formMenu.calcul.nutriscore_lettre_url" alt="">
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <json-viewer boxed :value="formMenu.calcul" />
                    </div>

                </div>
            </div>
        </div>

        <div class="row mb-3 d-flex justify-content-end">
            <div class="col-lg-4">
                <template v-if="formMenu.type == 'menu'">
                    <MenuTypeMenuList :form-menu="formMenu"  :role="role" />
                </template>
                <template v-if="formMenu.type == 'jour'">
                    <MenuTypeJourList :form-menu="formMenu" :role="role" />
                </template>
                <template v-if="formMenu.type == 'periode'">
                    <MenuTypePeriodeList :form-menu="formMenu" :role="role" />
                </template>
            </div>
            <div class="col-lg-8">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Recherche de recette</h3>
                    </div>
                    <div class="card-body">
                        <form id="formAddMenu" action="/pro/menus/" method="post">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group" v-if="role == 'admin'">
                                        <label class="form-label">Utilisateur</label>
                                        <el-select
                                            v-model="formMenu.user_id"
                                            placeholder="Select"
                                            filterable
                                            remote
                                            clearable
                                            :remote-method="searchUser"
                                            :loading="loading"
                                        >
                                            <el-option
                                                v-for="item in users"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label class="form-label">Categorie</label>
                                        <select v-model="category_id" name="category_id" class="form-control custom-select">
                                            <option :value="null">Sélectionner une categorie</option>
                                            <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="input-group col-12">
                                    <input v-model="q" name="q" type="text" class="form-control form-control-lg" placeholder="Risotto, Salade...">
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer text-right">
                        <div class="d-flex">
                            <a href="/pro/menus/" class="btn btn-link">Annuler</a>
                            <button @click.prevent="search" type="submit" class="btn btn-primary ml-auto">Rechercher</button>
                        </div>
                    </div>
                </div>
                <template v-if="formMenu.type == 'menu'">
                    <MenuTypeMenu :form-menu="formMenu"  :role="role" />
                </template>
                <template v-if="formMenu.type == 'jour'">
                    <MenuTypeJour :form-menu="formMenu" :role="role" />
                </template>
                <template v-if="formMenu.type == 'periode'">
                    <MenuTypePeriode :form-menu="formMenu" :role="role" />
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import JsonViewer from 'vue-json-viewer'
import MenuTypeMenu from "./MenuTypeMenu.vue";
import MenuTypeJour from "./MenuTypeJour.vue";
import eventBus from "../eventBus";
import MenuTypePeriode from "./MenuTypePeriode.vue";
import MenuTypeMenuList from "./MenuTypeMenuList.vue";
import MenuTypeJourList from "./MenuTypeJourList.vue";
import MenuTypePeriodeList from "./MenuTypePeriodeList.vue";
export default {
    components: {
        MenuTypePeriodeList,
        MenuTypeJourList, MenuTypeMenuList, MenuTypePeriode, MenuTypeJour, MenuTypeMenu, JsonViewer},
    props: ['menu', 'role', 'categories'],
    data() {
        return {
            users: [],
            loading: false,
            loadingRecipes: false,
            controllerRecipe: null,
            selectedUser: null,
            formMenu: {
                items: [],
                user_id: null,
                type: null,
                name: null,
            },
            debounceTimer: null,
            category_id: null,
            q: null,
            successMessage: null,
        }
    },
    mounted() {
        this.formMenu = {...this.formMenu, ...this.menu};
        if (this.formMenu.user_id) {
            this.loading = true;
            axios.get('/pro/users', {params: {'user_id': this.formMenu.user_id, select: true}})
                .then(response => {
                    this.users = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
        this.search();
    },
    methods: {
        search() {
            eventBus.$emit('search-' + this.formMenu.type, {
                q: this.q,
                category_id: this.category_id,
            })
        },
        debounce(func, delay) {
            // Si un appel précédent du timer existe, on le nettoie avant de relancer
            clearTimeout(this.debounceTimer);
            // Lancer le nouveau timer
            this.debounceTimer = setTimeout(() => {
                func();
            }, delay);
        },
        searchUser(query) {
            this.debounce(() => {
                console.log(query);
                if (query !== '') {
                    this.loading = true;
                    axios.get('/pro/users', {params: {q: query, select: true, limit: 20}})
                        .then(response => {
                            this.users = response.data.data;
                        })
                        .catch(error => {
                            console.log(error);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            }, 800);
        },
        async save()
        {
            let route = this.menu.id ? '/pro/menus/' + this.menu.id : '/pro/menus';

            let response = await axios.post(route, {
                items: this.formMenu.items.map(v => v.id),
                user_id: this.formMenu.user_id,
                type: this.formMenu.type,
                name: this.formMenu.name,
            });
            if(response.data.success) {
                this.successMessage = response.data.message;
                if(response.data.redirect) {
                    window.location.href = response.data.redirect;
                } else {
                    this.formMenu = response.data.data;
                }
            }
        }
    }

}
</script>

<style scoped>
.position-relative {
    position: relative;
}
    /* Overlay full covering */
.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7); /* Fond semi-transparent */
    z-index: 10;
}
.spinner-border {
    width: 3rem;
    height: 3rem;
}
</style>

